<template>
  <div class="c-buttonScrollInPageTop" v-show="buttonActive" @click="returnTop">
    <img
      src="/mc/assets/img/common/ic-bt-pagetop.png"
      alt="ページトップへスクロール"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttonActive: false,
      scroll: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollWindow);
  },
  methods: {
    returnTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollWindow() {
      const top = 100; // ボタンを表示させたい位置
      this.scroll = window.scrollY;
      if (top <= this.scroll) {
        this.buttonActive = true;
      } else {
        this.buttonActive = false;
      }
    },
  },
};
</script>

<style></style>
